// Wraps API calls in try/catch, and transforms action error details from AppSync so they're usable by matchRejecteds
// 
// 
export async function GqlErrorTransformer(fn) {
    try {
        return await fn();
    } catch (error) {
        console.error("Attempting to transform caught error", error);
        throw transformError(error);
    }
}

function transformError(o) {
    let ot = JSON.parse(JSON.stringify(o));
    
    if (!(ot?.errors?.length > 0)) { return ot; }

    const messages = ot.errors.map(err => err.message ?? "").join(". ");
    
    if (ot.message) { // Don't overwrite any message already there
        console.error("Message already exists, cannot overwrite. Ignored messages:", messages);
        return ot;
    } 
    
    ot.message = messages;    
    return ot;
}